export default __webpack_public_path__ + "static/media/error_500.df8f240a.png";